import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import get from 'lodash/get'
import { Nav, NavItem, NavLink } from 'reactstrap'
import "../../../static/css/index.css"

export const NavBar = class extends React.Component {
  shouldComponentUpdate(nextProps) {
    if (JSON.stringify(get(nextProps, 'timesheets')) === JSON.stringify(get(this.props, 'timesheets'))
    && get(nextProps, 'isEdit') === get(this.props, 'isEdit')
    && get(nextProps, 'activeTab') === get(this.props, 'activeTab')) return false
    return true
  }

  render() {
    const { isEdit, activeTab, toggleTab, handleDiscard, timesheets } = this.props
    const canSeeTimesheetStatus = get(timesheets, 'canSeeTimesheetStatus')
    const canSeeTimesheetByProject = get(timesheets, 'canSeeTimesheetByProject')
    const canSeeTimesheetApprovals = get(timesheets, 'canSeeTimesheetApprovals')

    return (
      <NavbarTab tabs>
        <TimesheetItem>
          <NavLinkTab
            style={ {
              color: (activeTab === 1) ? '#AD2624' : '',
              borderBottom: (activeTab === 1) ? '4px solid #AD2624' : '',
              borderTopStyle: 'none',
              borderLeftStyle: 'none',
              borderRightStyle: 'none',
            } }
            onClick={ () => {
              if (isEdit) handleDiscard('clickTab', 1)
              else toggleTab(1)
            }
            }
          >
                My Timesheet
          </NavLinkTab>
        </TimesheetItem>
        { canSeeTimesheetByProject && <TimesheetItem >
          <NavLinkTab
            style={ { color: (activeTab === 2) ? '#AD2624' : '',
              borderBottom: (activeTab === 2) ? '4px solid #AD2624' : '',
              borderTopStyle: 'none',
              borderLeftStyle: 'none',
              borderRightStyle: 'none',
            } }
            onClick={ () => {
              if (isEdit) handleDiscard('clickTab', 2)
              else toggleTab(2)
            }
            }
          >
              Timesheet by Projects
          </NavLinkTab>
        </TimesheetItem>
        }
        { canSeeTimesheetStatus && <TimesheetItem >
          <NavLinkTab
            style={ { color: (activeTab === 3) ? '#AD2624' : '',
              borderBottom: (activeTab === 3) ? '4px solid #AD2624' : '',
              borderTopStyle: 'none',
              borderLeftStyle: 'none',
              borderRightStyle: 'none',
            } }
            onClick={ () => {
              if (isEdit) handleDiscard('clickTab', 3)
              else toggleTab(3)
            }
            }
          >
            Timesheet Status
          </NavLinkTab>
        </TimesheetItem>
        }
        { canSeeTimesheetApprovals && <TimesheetItem >
          <NavLinkTab
            style={ {
              color: (activeTab === 4) ? '#AD2624' : '',
              borderBottom: (activeTab === 4) ? '4px solid #AD2624' : '',
              borderTopStyle: 'none',
              borderLeftStyle: 'none',
              borderRightStyle: 'none',
            } }
            onClick={ () => {
              if (isEdit) handleDiscard('clickTab', 4)
              else toggleTab(4)
            }
            }
          >
              Timesheet Approval
          </NavLinkTab>
        </TimesheetItem>
        }
      </NavbarTab>
    )
  }
}

NavBar.propTypes = {
  activeTab: PropTypes.number.isRequired,
  handleDiscard: PropTypes.func.isRequired,
  toggleTab: PropTypes.func.isRequired,
  isEdit: PropTypes.bool.isRequired,
  timesheets: PropTypes.object,
}
NavBar.defaultProps = {
  timesheets: {},
}

const NavbarTab = styled(Nav)`
  height: 100%;
  width: 100%;
  -webkit-box-shadow: 0px 1px 1px #F1F1F1;
  -moz-box-shadow: 0px 1px 1px #F1F1F1;
  box-shadow: 0px 1px 0px #F1F1F1;
  border: none;
  padding-top: 10px;
  @media (max-width: 575.98px) {
    display: none;
  }
  @media (max-width: 767.98px) {
    display: none;
  }
  @media (max-width: 991.98px) {
    margin-right: 1%;
  }
  .nav-link {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
`
const NavLinkTab = styled(NavLink)`
  height: 40px;
  padding-bottom: 20px;
  cursor: pointer;
  font-size: 12px;
  &:hover{
    border: none ;
  }
`
const TimesheetItem = styled(NavItem)`
  height: 30px ;
  .nav-link {
    display: block;
    @media (max-width: 1199.98px) {
      font-size: 10px;
      padding: 0.5rem 0.3rem !important;
    }
    @media (max-width: 991.98px) {
      font-size: 10px;
      padding: 0.5rem 0.3rem !important;
    }
    @media (max-width: 575.98px) {
      font-size: 12px;
      padding-bottom: 0px !important;
    }
    @media (max-width: 767.98px) {
      margin: auto;
    }
  }
`




// WEBPACK FOOTER //
// ./src/components/timesheet/tab/navbar.js